export default "__VITE_ASSET__DmF4jgiY__"